import React from 'react';
import styled from 'styled-components';

import type { LoadingLayoutProps } from '@typings/layout.ts';

import findByLayoutId from '../../utils/findByLayoutId.ts';

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: hidden;
`;

export default function ModLayout({ app, children, Loading, mapLoaded }: LoadingLayoutProps) {
  const map = findByLayoutId('map', children, app);
  const appInfo = findByLayoutId('appInfo', children, app);

  return (
    <Loading hasLoaded={mapLoaded}>
      <Wrapper>
        {map}
        {appInfo}
      </Wrapper>
    </Loading>
  );
}
